import { range } from "lodash";
import React from "react";

import { StyleConstants } from "../../../config/constants";
import SkeletonLoader from "../../common/SkeletonLoader";

import { MAX_GRID_RESULTS_PER_ROW } from "./withInsightsRenderer";

export const InsightsLoaderSkeleton: React.FunctionComponent = () => {
    return (
        <>
            {range(0, MAX_GRID_RESULTS_PER_ROW * 2).map((row, index) => (
                <SkeletonLoader
                    height={`${StyleConstants.InsightCardSize}px`}
                    width="100%"
                    key={`${row}_${index}`}
                />
            ))}
        </>
    );
};
